import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import AccessGroupColumns from "../../../models/ColumnDefinitions/AccessGroupColumns";
import AccessGroupSearch from "../../../models/search/AccessGroupSearch";
import { removeColumns } from "../../../models/utilities/columnHelper";
import { getAllAccessGroups } from "../../../services/accessGroupService";
import TableTab from "../../tabs/table-tab";

interface FloorGroupStepProps {
    onNext: (e: any) => void;
    onBack: (e: any) => void;
    setTotalFloorGroups: React.Dispatch<React.SetStateAction<number>>;
}

const FloorGroupStep: FC<FloorGroupStepProps> = ({ onNext, onBack, setTotalFloorGroups }) => {
    const { setFieldValue, values } = useFormikContext<any>();
    const { translate } = useLocale();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const onLocalNext = (e: any) => {
        setTotalFloorGroups(selectedIds.length);
        setFieldValue("floorGroups", selectedIds);
        setFieldValue("floorGroupRows", selectedRows);
        onNext(e);
    }

    const hasAtLeastOneSelection = selectedIds.length > 0 || (values.accessGroups && values.accessGroups.length > 0);

    return <div className="pt-3 pr-3 h-full relative">
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                dataMethod={(listParameters) => getAllAccessGroups(2, translate, listParameters)}
                tableDescriptor={removeColumns(AccessGroupColumns, ['days', 'startTime', 'duration', 'enrolments'])}
                searchDescriptor={AccessGroupSearch}
                useTable
                usePagination
                useFilter
                useSearch
                useSort>
                <TableTab
                    title={translate.byKey(TranslationKeys.floorGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    cyName="floorGroupStep"/>
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    id="nextBtn"
                    className={`py-1 px-5 secondary ${hasAtLeastOneSelection ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    disabled={!hasAtLeastOneSelection}
                    onClick={onLocalNext}>
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default FloorGroupStep;